const translationMap =
{
    "uk": {
        "Forgot password": "Забули пароль",
        "Authorization": "Авторизація",
        "Login": "Логін",
        "Password": "Пароль",
        "Delete": "Видалити",
        "Successfully removed": "Успішно видалено",
        "Check the data is correct": "Перевірте коректність даних",
        "Phone number": "Номер телефону",
        "Code from message": "Код з повідомлення",
        "Get code": "Отримати код",
    },

    "ro": {
        "Forgot password": "Ați uitat parola",
        "Authorization": "Autorizare",
        "Login": "Log in",
        "Password": "Parolă",
        "Delete": "Şterge",
        "Successfully removed": "S-a șters cu succes",
        "Check the data is correct": "Verificați dacă datele sunt corecte",
        "Phone number": "Număr de telefon",
        "Code from message": "Cod din mesaj",
        "Get code": "Obțineți codul",
    },

    "ru": {
        "Forgot password": "Забыли пароль",
        "Authorization": "Авторизация",
        "Login": "Логин",
        "Password": "Пароль",
        "Delete": "Удалить",
        "Successfully removed": "Успешно удалено",
        "Check the data is correct": "Проверьте корректность данных",
        "Phone number": "Номер телефона",
        "Code from message": "Код из сообщения",
        "Get code": "Получить код",
    }
};

export function translate(label: string, language: string): string {
    if (language === "en") {
        return label;
    }
    if (language in translationMap) {
        return translationMap[language][label];
    }
    language = navigator.language.split('-')[0];
    if (language in translationMap) {
        return translationMap[language][label];
    }
    return label;
}

export const TaxiServiceName = process.env.REACT_APP_TAXI_SERVICE_NAME || "MobilAuto";
export const TaxiServiceEmail = process.env.REACT_APP_TAXI_SERVICE_EMAIL || "support@mobilauto.com";
export const TaxiServiceDelete = process.env.REACT_APP_FULL_URL || "delete.me.mobilauto.com";
